import styled from 'styled-components';

export const StyledCarouselWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  padding: 24px;
  text-align: center;
  border: 1px solid rgb(97, 170, 178);
  background-color: #f5f9f9;
  border-radius: 21px;
  overflow: hidden;

  .corner_label {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 35px;
    right: -53px;
    width: 200px;
    height: 25px;
    transform: rotate(45deg);
    font-size: 12px;
    line-height: 12px;
    font-weight: 500;
    text-transform: uppercase;
    background-color: #d4d3d3;
    color: #9b9b9b;
    z-index: 1;

    @media (max-width: 767px) {
      top: 0;
      left: 0;
      width: 100%;
      transform: unset;
    }
  }

  .annonse_label {
    position: absolute;
    bottom: 8px;
    left: 20px;
    font-size: 9px;
    line-height: 12px;
    text-transform: uppercase;
    color: #afa7a7;
    font-weight: 500;
  }
`;

export const StyledCarouselContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  height: 100%;
  margin-bottom: 18px;

  h2 {
    font-size: 24px;
    line-height: 24px;
    color: #2f4d51;
    letter-spacing: 0.004em;
    margin: 6px 0;
  }

  h3 {
    font-size: 13px;
    line-height: 24px;
    letter-spacing: 0.004em;
    color: #000;
    margin: 0 0 6px 0;
  }

  p {
    margin: 0 0 50px 0;
  }

  .logo {
    width: 100%;
    max-width: 175px;
    margin: 25px auto;
    object-fit: contain;
  }
`;
